<template>
  <div id="result"></div>
</template>
<script>
import $ from 'jquery';
import Cookies from 'js-cookie';

export default{ 
  components:{},
  data(){
    return{
      sampleData:''
    };
  },
  setup(){},
  created(){},
  mounted(){

    $(document).ready(function() {

      $.get('https://m.childy.co.kr/data/skin/mobile/pixm22_mo/test/css/category.css', function(data) {
          // 로드된 CSS를 현재 문서에 추가
          $('<style>' + data + '</style>').appendTo('head');  
          $('#result').load('https://service.childy.co.kr/api/get_category.php .lnb-rn-wrap', function(response, status, xhr) {
            if (status == "error") {
                var msg = "Sorry but there was an error: ";
            } else {
              // Load 성공 시 외부 HTML 파일 내의 CSS 적용
              $(response).filter('link[rel="stylesheet"]').each(function() {
                  var href = $(this).attr('href');
                  if (href && !href.startsWith('https://')) {
                      // 외부 CSS 파일을 가져와서 현재 페이지에 적용
                      $('<link>').attr({
                          rel: 'stylesheet',
                          type: 'text/css',
                          href: 'https://m.childy.co.kr'+href
                      }).appendTo('head');
                  } else {
                      // 외부 CSS 파일을 가져와서 현재 페이지에 적용
                      $('<link>').attr({
                          rel: 'stylesheet',
                          type: 'text/css',
                          href: href
                      }).appendTo('head');
                  }
              });

                  /* menu js */
              let categoryOpenBtn = $('.side_menu') //카테고리 메뉴 open버튼 엘리먼트
              let categoryCloseBtn = $('.lnb-rn-closebtn') //카테고리 메뉴 close버튼 엘리먼트
              const categoryMenu = () => {
                let categoryLayer = document.querySelector('.lnb-rn-wrap')
                if (categoryLayer.style.display === 'block') {
                    categoryLayer.style.display = 'none'
                } else {
                    categoryLayer.style.display = 'block'
                }


                /* 카테고리 메뉴 높이값에 따른 라인위치 */
                let twoDepthHeight = $('.cate-twoDepth-wrap').height()
                $('.cate-oneDepth-wrap, .cate-twoDepth-wrap').css({height:twoDepthHeight})
              }

              /* 카테고리 메뉴 실행 */
              categoryOpenBtn.on('click', function(){
                  scrollNon() //스크롤 제어
                  categoryMenu()  //카테메뉴 오픈
              })
              categoryCloseBtn.on('click', function(){
                  scrollNon() //스크롤 제어
                  categoryMenu()  //카테메뉴 닫기
              })

              categoryMenu()
              let setLnb = document.querySelector('.lnb-rn-wrap')
              setLnb.style.display = 'none'

              const scrollNon = () => {
                let eleHtml = document.querySelector('html')
                if (eleHtml.style.overflow === 'hidden') {
                  eleHtml.style.overflow = ''
                  eleHtml.style.height = ''
                } else {
                  eleHtml.style.overflow = 'hidden'
                  eleHtml.style.height = '100%'
                }
              }

              /* 카테고리 메뉴 동작 */
              $('.cate-oneDepth-wrap > ul > li').on('click', function(){
                  $('.cate-oneDepth-wrap > ul > li').removeClass('oneActive') //원뎁스 엑티브 초기화
                  $('.cate-twoDepth-wrap > ul').removeClass('twoActive') //투뎁스 엑티브 초기화
                  $(this).addClass('oneActive') //원뎁스 엑티브

                  let currentIndex = $(this).index()
                  $('.cate-twoDepth-wrap > ul').eq(currentIndex).addClass('twoActive')
                  //alert(currentIndex)
              })

              // Swiper 라이브러리 로드
              $.getScript('https://cdnjs.cloudflare.com/ajax/libs/Swiper/6.8.4/swiper-bundle.min.js', function() {
                  // Swiper 라이브러리 로드 후에 실행되는 코드
                  var swiper = new Swiper('.lnb-rn-brand-roll-inner', {
                  slidesPerView: 'auto',
                  spaceBetween: 20,
                  centeredSlides: false,
                  grabCursor: true,
                  observer: true,
                  observeParents: true,
                })
              });
              
              //2023-05-11 tgk json 읽어서 내용 설정

              function newCate(data) {
                  let retArr = [];

                  $.each(data, function(key, value) {
                      retArr[key] = {};

                      $.each(value, function (key2, value2) {
                          retArr[key][value2.cateCd] = value2.cateNm;
                      });
                  });

                  return retArr;
              }

              // 현재 시간을 가져오기 위한 함수
              function getCurrentTime() {
                  var now = new Date();
                  var year = now.getFullYear();
                  var month = ('0' + (now.getMonth() + 1)).slice(-2);
                  var day = ('0' + now.getDate()).slice(-2);
                  var hours = ('0' + now.getHours()).slice(-2);
                  var minutes = ('0' + now.getMinutes()).slice(-2);
                  var seconds = ('0' + now.getSeconds()).slice(-2);
                  var timeString = year + month + day + hours + minutes + seconds;
                  return timeString;
              }

              var currentTime = getCurrentTime();
              $.getJSON('https://m.childy.co.kr/test2/commCode.json?time='+ currentTime,function(data) {

                  //메인 카테고리 추가
                  $.each(data.main_category,function(key,value) {
                      let temp_cate = $('#main_category_'+ key +' > li');
                      $.each(temp_cate, function (key2, element) {
                          //링크
                          //2023-06-23 tgk : 카테고리 임의 삭제 시 발생하는 문제 수정.
                          if (typeof value !== 'undefined' && typeof value[key2] !== 'undefined') {
                              $(element).find('a').attr('href', 'https://m.childy.co.kr/goods/goods_list.php?cateCd=' + value[key2].cateCd);
                              $(element).attr('cateCd',  value[key2].cateCd);
                              if(key2 > 0) {
                                  //카테고리명
                                  $(element).find('span.menu-txt').text( value[key2].cateNm);
                              }
                          }
                      })
                  })

                  //메인 카테고리 추가
                    $.each(data.main_category,function(key,value) {
                        $.each(value, function (key2, value2) {
                            if(value2.cateCd.length > 3) {
                                $('#main_category_'+ key).append('<li><a href="https://m.childy.co.kr/goods/goods_list.php?cateCd='+ value2.cateCd +'"><span class="menu-img"><img src="https://m.childy.co.kr/test2/cate_icon/CateIcon_'+ value2.cateCd +'.png"></span><span class="menu-txt">'+ value2.cateNm +'</span></a></li>');
                            }
                        });
                    })

                  //부티크 리스트 추가
                  data.category_boutique.reverse(); //앞쪽에 추가 하므로 역순으로 정렬
                  $.each(data.category_boutique,function(key,value) {
                      let tempVersion = null;
                      var tempTimestamp = Math.floor(Date.parse(value.modDt) / 1000);

                      var newListItem=`<li class="swiper-slide">
                      <a href="`+value.link+`">
                      <span class="icon"><img src="https://m.childy.co.kr/`+value.imgSrc+'?v='+tempTimestamp+`"></span>
                      <p>`+value.codeName+`</p>
                      </a>
                      </li>`;
                      // 새로운 li 요소를 첫 번째 li 앞에 추가
                      $('#category_boutique li:first-child').before(newListItem);
                  })

                  //패밀리몰 리스트 추가
                  data.category_family.reverse(); //앞쪽에 추가 하므로 역순으로 정렬
                  $.each(data.category_family,function(key,value) {
                      let tempVersion = null;
                      var tempTimestamp = Math.floor(Date.parse(value.modDt) / 1000);

                      var newListItem=`<li class="swiper-slide">
                      <a href="https://m.childy.co.kr`+value.link+`">
                      <span class="icon"><img src="https://m.childy.co.kr/`+value.imgSrc+'?v='+tempTimestamp+`"></span>
                      <p>`+value.codeName+`</p>
                      </a>
                      </li>`;
                      // 새로운 li 요소를 첫 번째 li 앞에 추가
                      $('#category_family li:first-child').before(newListItem);
                  })

                  //옷마카세 리스트 추가
                  $.each(data.category_otmakase,function(key,value) {
                      let tempVersion = null;
                      var tempTimestamp = Math.floor(Date.parse(value.modDt) / 1000);

                      var newListItem=`<li>
                      <a href="https://m.childy.co.kr`+value.link+`">
                          <span class="img"><img src="https://m.childy.co.kr/`+value.imgSrc+'?v='+tempTimestamp+`" alt=""></span>
                          <strong>`+value.codeName+`</strong>
                      </a>
                      </li>`;
                      // 새로운 li 요소를 첫 번째 li 앞에 추가
                      $('#category_otmakase').append(newListItem);
                      if(key>2) {
                          return false; // 루프 종료
                      }
                  })
                  //함수가 존재 할때만 호출.
                  if(typeof goods_list_getjson === 'function') {
                      goods_list_getjson(data);
                  }
                  if(typeof commonCodeGetJson === 'function') {
                      commonCodeGetJson(data);
                  }
                  if(typeof searchTag === 'function') {
                      searchTag(data);
                  }
                  if(typeof topGnb === 'function') {
                      topGnb(data);
                  }
                  
              })
              

              //앱 접속시 PC화면 보기 비노출로 설정
              if(navigator.userAgent.match('Byapps')){
                  //$('.fixed_footer').css({'display':'none'});
                  $('.lnb-rn-appsetting').css({'display':'block'});
              }
              
              // 세션 스토리지에 객체 저장 함수
              function saveSessionObject(object) {
                  localStorage.setItem('recentCateList', JSON.stringify(object));
              }
              // 세션 스토리지에서 객체 불러오기 함수
              function loadSessionObject() {
                  var object = JSON.parse(localStorage.getItem('recentCateList'));
                  if (object) {
                      var itemList = $('#recentCateList');
                      itemList.empty(); // 리스트 초기화
                      // 객체의 각 속성을 리스트로 추가
                      $.each(object, function(key, item) {
                          var listItem = ` <li>
                              <div class="lnb-link"><a href="https://m.childy.co.kr/goods/goods_list.php?cateCd=`+key+`">`+item.value+`</a></div>
                              <div class="lnb-recentKeyword-delete"><button type="button" class="js_recent_keyword_delete" onClick="deleteRecentCate('`+key+`')">삭제</button></div>
                          </li>`;
                          itemList.append(listItem);
                      });

                      if($(itemList).find('li').length < 1) {
                          var listItem = ` <li class="no-lnb-recentKeyword">
                              <span><img src="https://img.childy.kr/img/m_bn/ui_renew/brand-blank-img.svg" alt=""></span>
                              <p>최근 본 카테고리가 없습니다.</p>
                          </li>`;
                          $('.lnb-recentKeyword-delAll').hide()
                          itemList.append(listItem);
                      }
                  } else {
                      var itemList = $('#recentCateList');
                      itemList.empty(); // 리스트 초기화
                      if($(itemList).find('li').length < 1) {
                          var listItem = ` <li class="no-lnb-recentKeyword">
                              <span><img src="https://img.childy.kr/img/m_bn/ui_renew/brand-blank-img.svg" alt=""></span>
                              <p>최근 본 카테고리가 없습니다.</p>
                          </li>`;
                          $('.lnb-recentKeyword-delAll').hide()
                          itemList.append(listItem);
                      }
                  }
              }

              // Add Item 버튼 클릭 시 아이템 추가
              $('.cate-twoDepth-list > li').click(function() {
                  var tempDepth2 = $(this).find('span.menu-txt').text();
                  var tempDepth1 = $(this).parent().attr('data');
                  var tempCateCd = $(this).attr('cateCd');
                  var key = tempCateCd;
                  var value = tempDepth1 + ' > ' + tempDepth2;
                  
                  var object = JSON.parse(localStorage.getItem('recentCateList')) || {};
                  object[key] = {
                      value: value,
                      timestamp: new Date().getTime() // 현재 시간값 저장
                  }

                  // 최대 5개 아이템 유지
                  var itemKeys = Object.keys(object);
                  if (itemKeys.length > 5) {
                      var oldestKey;
                      var oldestTimestamp = Infinity;
                      $.each(object, function(key, item) {
                          if (item.timestamp < oldestTimestamp) {
                              oldestKey = key;
                              oldestTimestamp = item.timestamp;
                          }
                      });
                      delete object[oldestKey];
                  }
                  saveSessionObject(object); // 객체 저장
                  loadSessionObject(); // 객체 다시 불러오기
              })

              // 모두삭제 클릭 이벤트 처리
              $('.lnb-recentKeyword-delAll').click(function() {
                  deleteAllCate();
              });

              // 페이지 로드 시 객체 불러오기
              loadSessionObject();

              // Delete Item 버튼 클릭 시 특정 아이템 삭제
              function deleteRecentCate(keyToDelete) {
                  var object = JSON.parse(localStorage.getItem('recentCateList'));
                  if (object && object.hasOwnProperty(keyToDelete)) {
                      delete object[keyToDelete];
                      saveSessionObject(object); // 객체 저장
                      loadSessionObject(); // 객체 다시 불러오기
                  }
              }
              // Delete Object 버튼 클릭 시 myObject 삭제
              function deleteAllCate() {
                  localStorage.removeItem('recentCateList');
                  loadSessionObject(); // 객체 다시 불러오기
              }
            }
          })
        })
      })

      //카테고리 로그인정보
      let isCookieElementAdded = false; 
      $('.side_menu').click(() => {
        if (!isCookieElementAdded) { // 요소가 추가되지 않았다면
            this.decodeCookie(); // 쿠키를 디코드하고 UI에 요소 추가
            isCookieElementAdded = true; // 요소가 추가되었음을 표시
        }
      })
  },
  unmounted(){},
  methods:{
    async decodeCookie() {
        try {
            let encodedCookie = await Cookies.get('memInfo');
            if (encodedCookie) {
                let decodedCookie = JSON.parse(decodeURIComponent(encodedCookie));
                // console.log(encodedCookie)
                // console.log(decodedCookie.memNm); // memNm 값 출력
                // console.log(decodedCookie.groupSno); // groupSno 값 출력

                var lnbRnTxt = document.querySelector('.lnb-rn-txt');
                if (lnbRnTxt) {
                    var newElement = document.createElement('span');
                    newElement.classList.add('my-level');
                    newElement.innerHTML = `
                        <img src="https://img.childy.kr/img/m_bn/ui_renew/level-0${decodedCookie.groupSno}.svg" alt="">
                    `;
                    lnbRnTxt.parentNode.insertBefore(newElement, lnbRnTxt);
                    lnbRnTxt.innerHTML = `
                    <p class="lnb-rn-txt">
                        <span class="my-name">${decodedCookie.memNm}</span>
                        <span>회원님, 반갑습니다!</span>
                    </p>
                    `;
                }
            } else {
                console.log('memInfo 쿠키를 찾을 수 없습니다.');
            }
        } catch (error) {
        console.error('쿠키를 가져오는 동안 오류가 발생했습니다:', error);
        }
    }
  }
}
</script>

<style>
#result{
    max-width:520px;
    width:100%;
    margin:0 auto;
}
.lnb-rn-brand-roll .swiper-wrapper{
    height: initial !important;
}
.lnb-rn-menu-wrap .cate-oneDepth-wrap, .lnb-rn-menu-wrap .cate-twoDepth-list{
    height: 396px;
}
svg{
  display: inline-block;
}
</style>